import React from 'react';
import { PropTypes } from 'prop-types';
import countryMap from 'i18n/country-map';
import SelectList from 'components/FormInputs/SelectList';
import { withTranslation } from 'react-i18next';

const CountrySelect = withTranslation()(props => (
  <div>
    <SelectList
      name={props.name}
      label={props.t(['addressForm.country', 'Country'])}
      prompt={props.t(['addressForm.selectACountry', 'Select a Country'])}
      data={countryMap}
      valueField="isoCode"
      textField="name"
      autoComplete="country"
      {...props}
    />
  </div>
));

CountrySelect.propTypes = {
  name: PropTypes.string,
};

CountrySelect.defaultProps = {
  name: undefined,
};

export default CountrySelect;
